import Vue from 'vue';
import Component from 'vue-class-component';

import ProductBlock from 'common/components/ProductBlock';
import Rating from 'common/components/Rating';
import currency from 'common/filters/currency';

Vue.filter('currency', currency);

@Component({
  components: {
    ProductBlock,
    Rating,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    selectedMonth: {
      type: String,
      required: false,
    },
    productTitle: {
      type: String,
      default: 'Escapada:',
    },
    bigBlock: {
      type: Boolean,
      default: true,
      description:
        'Change styles of the Block. True if 3 blocks will be displayed in a row',
    },
    showHeart: {
      type: Boolean,
      default: true,
    },
    campaignColor: {
      type: String,
      required: false,
    },
    showPrice: {
      type: Boolean,
      required: false,
    },
    showmiddleSlot: {
      type: Boolean,
      default: true,
    },
  },
})
export default class NewPackageBlockComponent extends Vue {
  travelActivities = this.activity.activities;

  get goToPackage() {
    const { slug } = this.activity;
    return {
      name: 'package',
      params: { slug },
      query: { mes: this.selectedMonth },
    };
  }

  get description() {
    if (this.activity.short_description) {
      return this.activity.short_description;
    } else if (this.activity.description) {
      return this.activity.description;
    }
    return '';
  }

  get nights() {
    return this.activity.min_season_price?.nights;
  }

  get minPrice() {
    return this.activity.min_season_price?.price;
  }

  /**
   * Subtract 1 from the array's length 'cause staying in the hotel doesn't count as an "experience"
   * We must show the real amount of experiences
   */
  get activityCount() {
    return this.activity.activity_count - 1;
  }
}
